export const YOU_TUBE = 'youtube';
export const isVideoType = (actionType) => (actionType === YOU_TUBE);
